import { AttributionMode, Journey } from 'modules/domains/campaign';

/**
 * TODO: Remove this once the backend is ready.
 * Feel free to replace `projectGoals` with this for your testing.
 */
export const MOCK_PROJECT_GOALS: Journey['goals'] = [
  {
    isActive: true,
    conversions: [
      {
        attributionMode: AttributionMode.AttributionPeriod,
        eventName: '$1000_GIFT_CARD',
        attributionPeriodHours: 12,
      },
    ],
  },
];

export enum InheritedConversionSource {
  CampaignEditor = 'campaignEditor',
  JourneyStudio = 'journeyStudio',
}

export const INHERITED_CONVERSION_ATTRIBUTION_TOOLTIPS_BY_SOURCE = {
  [InheritedConversionSource.CampaignEditor]: {
    projectGoalsAttribution: 'Attribution selection inherited from project goal',
    journeyGoalsAttribution: 'Update attribute selection at journey goal level',
  },
  [InheritedConversionSource.JourneyStudio]: {
    projectGoalsAttribution:
      'Attribution is determined by the parent project’s Conversion settings',
    journeyGoalsAttribution:
      'Attribution is determined by the parent Journey’s Conversion settings',
  },
};
